import * as types from './mutation-types'

export default {
  [types.SET_HOT_PICKUP_SELECTED_POSTCODE] (state, postcode) {
    state.hotPickupSelectedPostcode = postcode
  },

  [types.SET_HOT_PICKUP_SELECTED_PREFECTURE] (state, prefecture) {
    state.hotPickupSelectedPrefecture = prefecture
  },

  [types.SET_HOT_PICKUP_SELECTED_CITY] (state, city) {
    state.hotPickupSelectedCity = city
  },

  [types.SET_HOT_DELIVERY_SELECTED_POSTCODE] (state, postcode) {
    state.hotDeliverySelectedPostcode = postcode
  },

  [types.SET_HOT_DELIVERY_SELECTED_PREFECTURE] (state, prefecture) {
    state.hotDeliverySelectedPrefecture = prefecture
  },

  [types.SET_HOT_DELIVERY_SELECTED_CITY] (state, city) {
    state.hotDeliverySelectedCity = city
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ui/mutations.js